// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__rxUQX","footer_dark":"footer_footer_dark__bNL8I"};